import { safeClone, ViewStream, DomElement } from "spyne";
import { PageTraits } from "traits/page-traits";
import { PageDocsItem } from "components/pages/page-docs-item";
import { PageHomeCallout } from "components/pages/page-home-callout";
import { CodePlaygroundContainer } from "components/code-playground/code-playground-container";
import { PageHomeStructuralApi} from 'components/ui/page-home-structural-api';

import HeroTmpl from "./templates/landing-templates/landing-hero.tmpl.html";
import StructuralAPITmpl from "./templates/landing-templates/landing-structural-api.tmpl.html";
import AppDemoTmpl from "./templates/landing-templates/landing-app-demo.tmpl.html";
import VBLHellWorldTmpl from "./templates/landing-templates/landing-vbl.tmpl.html";
import StartBuildingTmpl from "./templates/landing-templates/landing-start-building.tmpl.html";
import AuthorObserverTmpl from "./templates/landing-templates/landing-author-observer.tmpl.html";
import ClosingCTATmpl from "./templates/landing-templates/landing-closing-cta.tmpl.html";
//const MySVG  = require('../../../static/imgs/svgs/gears.svg');
const compareReact = require("imgs/compare-apps-react.png");
const compareAngular = require("imgs/compare-app-angular.png");
import VBLDiagram from 'imgs/svgs/vbl-diagram-dark.svg';
import iconCheckbox from 'imgs/icon-checkbox.png';

export class PageHome extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.pageData);
    props.id = "l1-home";
    props.class = "app-page";
    const len = props.appData.content.length;
   // props.data.appData = props.appData.content[len - 1];
    //props.data["compareReact"] = compareReact;
   // props.data["compareAngular"] = compareAngular;
    props.data["heroContent"] = props.appData.homePageHeroContent;
  //  props.data.iconCheckbox = iconCheckbox;
    //console.log("home data ",props.data);
    //console.log('compare angular ',props.data.compareAngular);
    props.template = require("./templates/page-home.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    const containsLinks = this.props.el$("a").exists;
    const broadcastEls = containsLinks ? ["a", "click"] : [];
    return [broadcastEls];
  }

  addPageDocItems() {
    const addPageItems = (data) => {
      this.appendView(new PageDocsItem({ data }), ".page-home-content");
    };

    this.props.appData.homePageContent.forEach(addPageItems);
  }

  addHomeCards() {
    const { heroCallouts } = this.props.data?.heroContent ?? [];

    //console.log('hero content is ',heroCallouts);

    const addCallouts = (data) => {
      this.appendView(new PageHomeCallout({ data }), ".home-callouts");
    };

    //heroCallouts.forEach(addCallouts);
  }

  addVBLDiagram(){
     const template = `<div class='vbl-svg-holder'>${VBLDiagram}</div>`

    const vblEl = new DomElement({template})
    this.props.el$('#page-header').el.appendChild(vblEl.render());

  }

  onRendered() {
    // this.prependView(new ViewStream({template : `${MySVG.default}`}))

    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();

    //this.addHomeCards();
    //this.addVBLDiagram();

    this.page$ScrollToTopOnLoad();
    //this.addPageDocItems();

    this.appendView(new ViewStream({template : HeroTmpl}), "#page-header")
    //this.appendView(new ViewStream({template : StructuralAPITmpl}), "#page-header")
    this.appendView(new PageHomeStructuralApi(), "#page-header");
    this.appendView(new ViewStream({template : AppDemoTmpl}), "#page-body")
    this.appendView(new ViewStream({template : VBLHellWorldTmpl}), "#page-body")
    this.appendView(new ViewStream({template : StartBuildingTmpl}), "#page-body")
    this.appendView(new ViewStream({template : AuthorObserverTmpl}), "#page-body")
    this.appendView(new ViewStream({template : ClosingCTATmpl}), "#page-body")
    this.appendView(new CodePlaygroundContainer({codeBlockId: "home"}), ".code-container-holder");
    // this.appendView(new CodePlaygroundContainer({codeBlockId: "homePageTest2"}), ".page-content");
    //this.appendView(new CodePlaygroundContainer(), ".page-content");
  }
}
